var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLoad = function SvgLoad(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0075FF",
    d: "M4.479 8.4h11.2v11.2h-11.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#081236",
    d: "M15.68 8.4h7.84v11.2h-7.84z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9FAFF",
    d: "M8.4 8.4h2.24v3.36H8.4z"
  })));
};
export default SvgLoad;